import bgEliteMedium from "../res/elite/frame_md@2x.png";
import bgEliteSmall from "../res/elite/frame_sm@2x.png";
import bgModernMedium from "../res/modern/frame_md@2x.png";
import bgModernSmall from "../res/modern/frame_sm@2x.png";
import bgSimpleMedium from "../res/simple/frame_md@2x.png";
import bgSimpleSmall from "../res/simple/frame_sm@2x.png";
// eslint-disable-next-line import/order
import { PropsWithChildren } from "react";
import { cn } from "@/core/helpers/cn";

type FrameSize = "sm" | "md";
type FrameVariant = "simple" | "modern" | "elite";

type FrameProps = PropsWithChildren<{
  size: FrameSize;
  variant: FrameVariant;
}>;

const variants = {
  simple: {
    sm: {
      bg: bgSimpleSmall,
      size: {
        width: 246,
        height: 192,
      },
    },
    md: {
      bg: bgSimpleMedium,
      size: {
        width: 246,
        height: 409,
      },
    },
  },
  modern: {
    sm: {
      bg: bgModernSmall,
      size: {
        width: 246,
        height: 211,
      },
    },
    md: {
      bg: bgModernMedium,
      size: {
        width: 246,
        height: 428,
      },
    },
  },
  elite: {
    sm: {
      bg: bgEliteSmall,
      size: {
        width: 242,
        height: 182,
      },
    },
    md: {
      bg: bgEliteMedium,
      size: {
        width: 242,
        height: 433,
      },
    },
  },
};

export function WidgetFrame({ children, size, variant }: FrameProps) {
  const bgImage = variants[variant][size].bg;
  const { width, height } = variants[variant][size].size;

  return (
    <div
      className={cn("relative", "bg-cover p-[14px]")}
      style={{ backgroundImage: `url(${bgImage})`, width, height }}
    >
      {children}
    </div>
  );
}
